import { createSlice } from '@reduxjs/toolkit';

import { PhotoMapState } from 'types/photoMap';
import { INITIAL_LIST_PARAMS } from 'config';

const initialState: PhotoMapState = {
  isLoading: false,
  photoMapList: {},
  photoMapListParams: INITIAL_LIST_PARAMS,
  filtersListParams: INITIAL_LIST_PARAMS,
};

const slice = createSlice({
  name: 'photoMap',
  initialState,
  reducers: {
    startLoading(state) {
      state.isLoading = true;
    },

    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    resetError(state) {
      state.error = undefined;
    },

    getPhotoMapListSuccess(state, action) {
      state.isLoading = false;
      state.photoMapList = action.payload;
    },

    setPhotoMapListParams(state, action) {
      state.photoMapListParams = action.payload;
    },

    setFiltersListParams(state, action) {
      state.filtersListParams = action.payload;
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
export const {
  startLoading,
  hasError,
  resetError,
  getPhotoMapListSuccess,
  setPhotoMapListParams,
  setFiltersListParams,
} = slice.actions;
